/* Component Dependencies */
var enrollmentWidgetTemplate = require('templates/enrollmentWidget.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'enrollmentWidget',
  template: {
    'enrollmentWidget': enrollmentWidgetTemplate
  }
});
